import React, { useState } from "react";
import { FaTrash } from "react-icons/fa";
import { httpReauest } from "../../utils/httpRequest";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const AddressItem = ({ data, selected, onSelect, onDeleteSuccess }) => {
  const [showConfirm, setShowConfirm] = useState(false);
  const { t } = useTranslation();

  const handleDelete = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return;

    try {
      await httpReauest(
        "DELETE",
        "/user/delete/address",
        { addressId: data._id, userId: user._id },
        { "x-access-token": user.token }
      );
      toast.success(t("address_deleted_success"));
      setShowConfirm(false);
      onDeleteSuccess?.(); // فراخوانی مجدد لیست از والد
    } catch (error) {
      toast.error(t("address_deleted_error"));
      console.error("خطا در حذف آدرس:", error);
    }
  };

  return (
    <>
      <span
        className="flex gap-2 justify-between items-center w-full text-[14px] cursor-pointer"
        onClick={onSelect}
      >
        <span className="flex items-center gap-3">
          <span>
            <input type="radio" checked={selected} readOnly />
          </span>
          <span>
            <h4 className="font-bold">{data.name || "آدرس"}</h4>
            <p className="text-[#666]">{data.desc}</p>
          </span>
        </span>

        <span
          onClick={(e) => {
            e.stopPropagation();
            setShowConfirm(true);
          }}
          className="text-red-600 hover:text-red-800"
        >
          <FaTrash size={16} />
        </span>
      </span>

      {/* مدال تایید حذف */}
      {showConfirm && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">
          <div className="bg-white p-6 rounded-xl shadow-xl w-[90%] max-w-sm text-center">
            <h3 className="text-lg font-bold mb-4">
              {t("address_delete_confirm_title")}
            </h3>
            <p className="text-sm text-gray-600 mb-6">
              {t("address_delete_confirm_text")}
            </p>
            <div className="flex justify-center gap-4">
              <button
                onClick={() => setShowConfirm(false)}
                className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
              >
                {t("cancel")}
              </button>
              <button
                onClick={handleDelete}
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
              >
                {t("yes_delete")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddressItem;
